import { Tables } from "@/lib/supabase/supabase_types_override";
import { createQuestionIdMapping } from "./createQuestionIdMapping";
import { InvalidConditionalReferenceChange } from "@/features/survey_sync/types/syncCheckResult";
import { CommonProperties } from "@/types/utils";

export const checkForInvalidConditionalReferences = (
  question: Tables<"question">,
  surveyQuestions: Tables<"question">[]
): InvalidConditionalReferenceChange | false => {
  const questionConditionals = question.selected_configuration?.conditionals;
  if (!questionConditionals) return false;

  // Create question mappings (not used but keeping for potential future use)
  createQuestionIdMapping(surveyQuestions);

  // Extract all question IDs referenced in conditionals
  const extractReferencedIds = (obj: any, referencedIds: Set<string> = new Set()): Set<string> => {
    if (Array.isArray(obj)) {
      obj.forEach(item => extractReferencedIds(item, referencedIds));
    } else if (typeof obj === "object" && obj !== null) {
      Object.entries(obj).forEach(([key, value]) => {
        // Check if this key is in the 'where' clause which contains question references
        if (key === 'where' && typeof value === 'object' && value !== null) {
          // Only consider keys that look like valid question IDs (UUIDs or template-q patterns)
          Object.keys(value).forEach(questionId => {
            if (typeof questionId === 'string' && (
                questionId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) ||
                questionId.startsWith('template-q')
            )) {
              referencedIds.add(questionId);
            }
          });
        }
        extractReferencedIds(value, referencedIds);
      });
    }
    return referencedIds;
  };

  const referencedIds = extractReferencedIds(questionConditionals);

  // Check if any referenced question ID doesn't exist in the survey
  const invalidReferences: Tables<"question">["id"][] = [];

  Array.from(referencedIds).forEach(referencedId => {
    // Check if the referenced ID exists in the current survey questions
    const exists = surveyQuestions.some(q => q.id === referencedId);
    if (!exists) {
      invalidReferences.push(referencedId);
    }
  });

  if (invalidReferences.length > 0) {
    return {
      type: "INVALID_CONDITIONAL_REFERENCE",
      context: {
        invalidReferences,
        availableQuestions: surveyQuestions,
      },
    };
  }

  return false;
};